/**
 * @description Classe para manipulação de armazenamento local 
 * @author Wellington Pereira
 * @since 2014-03-11
 * @version 6.0.0
 */
class Storage {
    /**
     * Limpa todos os itens armazenados localmente.
     *
     * @returns {null}
     */
    clear() {
      localStorage.clear();
      return null;
    }

    /**
     * Exclui um item armazenado
     * 
     * @param {string} key 
     * @returns {null};
     */
    delete(key) {
      localStorage.removeItem(key);
      return null;
    }
  
    /**
     * Recupera um item armazenado
     * 
     * @param {string} key
     * @returns {mixed} Retorna o valor armazenado passado 
     */
    get(key) {
      let item = localStorage.getItem(key);
      if (/^\{.+\}$/.test(item) || /^\[.+\]$/.test(item)) {
        item = JSON.parse(item);
      }
      return item;
    }
  
    /**
     * Armazena um item
     * 
     * @param {string} key 
     * @param {mixed} value 
     * @returns {mixed} Retorna o valor passado 
     */
    set(key, value) {
      let newValue = null;
      if (typeof value === 'object') {
        newValue = JSON.stringify(value);
      } else {
        newValue = value;
      }
  
      localStorage.setItem(key, newValue);
      return value;
    }
  }
  
  const storage = new Storage();
  export default storage;
